import * as React from 'react';

/**
 * Возвращает, есть ли у этого элемента displayName
 * @param child
 */
export const hasDisplayName = (
  child: any
): child is { type: { displayName: string } } => {
  const childType = React.isValidElement(child) && child.type;

  if (
    childType &&
    (typeof childType === 'object' || typeof childType === 'function')
  ) {
    return 'displayName' in childType;
  }

  return false;
};
